<template>
  <div>
    <Head />
    <div class="wrap">
      <h1>Алимов Илдар Феридович</h1>
      
        <br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br>
     
    </div>
    <Foot />
  </div>
</template>

<script>
import Head from '@/components/Head.vue'
import Foot from '@/components/Foot.vue'

export default {
  name: 'BnuView',
  components: {
    Head,
    Foot,
  }
}
</script>

<style scoped>
.wrap {
  max-width: 90%;
  margin: 60px auto;
}

.ii {
  width: 100%;
  overflow: hidden;
  object-fit: cover;
}


@media (max-width: 790px) {

  

}

</style>

